import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';

@Component({
  selector: 'app-document-repository',
  standalone: true,
  imports: [CommonModule, ToolbarComponent, FooterComponent],
  templateUrl: './document-repository.component.html',
  styleUrl: './document-repository.component.scss',
})
export class DocumentRepositoryComponent {}
